import { render, staticRenderFns } from "./EditContentPage.vue?vue&type=template&id=99abb48c"
import script from "./EditContentPage.vue?vue&type=script&lang=js"
export * from "./EditContentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports